import './card-slider.scss';

import Swiper from 'swiper';
import { tryParseJSON } from '../../utilities/js/helper';
import { A11y, EffectCards, Navigation, Pagination, Keyboard } from 'swiper/modules';

class CardSlider {
    constructor ($element) {
        this.$slider = $element;
        this.$$slides = this.$slider.querySelectorAll('.swiper-slide');
        this.slider = null;
        this.sliderActive = false;

        this.sliderSettings = this.$slider.getAttribute('data-slider-settings');
        if (this.sliderSettings) {
            this.sliderSettings = tryParseJSON(this.sliderSettings);
        }
    }

    initialize () {
        if (this.$$slides.length > 1) {
            this.checkSize();
            this.setEvents();

            this.$slider.classList.add('slides__items--length-' + this.$$slides.length);
        }
    }

    checkSize () {
        if (!window.mediaMatchHandler[768].matches) {
            this.destroySlider();
            this.initSlider('mobile');
        } else {
            this.destroySlider();
            this.initSlider();
        }
    }

    setEvents () {
        [1920, 1440, 1024, 768, 320].forEach((bp) => {
            window.mediaMatchHandler[bp].addEventListener('change', () => {
                this.checkSize();
            });
        });
    }

    initSlider (type = 'desktop') {
        this.sliderActive = true;
        this.$progressbar = this.$slider.querySelector('.swiper-pagination-progressbar-fill');

        let centeredSlides = false;
        let centeredSlidesBounds = false;

        if (this.sliderSettings && 'centered' in this.sliderSettings && this.sliderSettings.centered === true) {
            centeredSlides = true;
        }

        if (this.sliderSettings && 'centeredSlidesBounds' in this.sliderSettings && this.sliderSettings.centeredSlidesBounds === true) {
            centeredSlidesBounds = true;
        }

        let breakpoints = null;
        if (this.sliderSettings && 'breakpoints' in this.sliderSettings && typeof this.sliderSettings.breakpoints === 'object') {
            breakpoints = this.sliderSettings.breakpoints;
        } 

        const updateProgressbar = (length, index) => {
            const progress = 100 / length * (index + 1);
            if (this.$progressbar) {
                this.$progressbar.style.width = progress + '%';
            }
        };

        this.$prevButton = this.$slider.querySelector('.swiper-button-prev');
        this.$nextButton = this.$slider.querySelector('.swiper-button-next');
        this.$fraction = this.$slider.querySelector('.swiper-pagination');

        const defaultSettings = {
            a11y: {
                prevSlideMessage: 'Vorheriger Slide',
                nextSlideMessage: 'Nächster Slide',
                paginationBulletMessage: 'Springe zu Slide {{index}}',
                firstSlideMessage: 'Dies ist der erste Slide',
                lastSlideMessage: 'Dies ist der letzte Slide',
                slideLabelMessage: 'Slide {{index}} von {{slidesLength}}'
            },
            speed: 500,
            slidesPerView: 'auto',
            lazyPreloadPrevNext: true,
            pagination: {
                el: this.$fraction,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.$nextButton,
                prevEl: this.$prevButton
            },
            keyboard: true,
            watchSlidesProgress: true,
            on: {
                init: (swiper) => {
                    updateProgressbar(swiper.snapGrid.length, swiper.activeIndex);
                },
                slideChangeTransitionStart: (swiper) => {
                    updateProgressbar(swiper.snapGrid.length, swiper.activeIndex);
                },
                lock: (swiper) => {
                    if (swiper.isLocked) {
                        this.$slider.classList.add('swiper-locked');
                        this.$slider.closest('.slider').classList.remove('slider--unlocked');
                    }
                },
                unlock: (swiper) => {
                    if (!swiper.isLocked) {
                        this.$slider.classList.remove('swiper-locked');
                        this.$slider.closest('.slider').classList.add('slider--unlocked');
                    }
                },
                resize: (swiper) => {
                    updateProgressbar(swiper.snapGrid.length, swiper.activeIndex);
                }
            }
        };

        let breakpointSettings = null;

        if (type === 'mobile') {
            breakpointSettings = {
                modules: [A11y, EffectCards, Navigation, Pagination, Keyboard],
                centeredSlides: true,
                centeredSlidesBounds: true,
                effect: 'cards',
                cardsEffect: {
                    rotate: true,
                    perSlideRotate: 2,
                    perSlideOffset: 3,
                    slideShadows: false
                }
            };
        }

        if (type == 'desktop') {
            breakpointSettings = {
                modules: [A11y, Navigation, Pagination, Keyboard],
                centeredSlides: centeredSlides,
                centeredSlidesBounds: centeredSlidesBounds,
                breakpoints: breakpoints, 
            };
        }

        const mergedSettings = Object.assign({}, defaultSettings, breakpointSettings);
        this.slider = new Swiper(this.$slider, mergedSettings);
    }

    destroySlider () {
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider = null;
            this.sliderActive = false;

            if (this.$fraction) {
                this.$fraction.innerHTML = '';
            }
        }
    }
}

export { CardSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$cardSlider = $context.querySelectorAll('[data-cardslider="root"]');

        for (let i = 0; i < $$cardSlider.length; i++) {
            const cardSlider = new CardSlider($$cardSlider[i]);
            cardSlider.initialize();
        }
    }
});
